import React from "react";
import { createUseStyles } from "react-jss";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { getColorOptions } from "./theming/colorOptions";
import { ColorOptions } from "./types";
import { classNames } from "./utils/classNames";
import parseChildren from "./utils/parseChildren";
const GLYPHICON_FEEDBACK_TYPE_MAP = {
    error: {
        glyphicon: "remove-sign",
        color: ColorOptions.Red,
    },
    warning: {
        glyphicon: "exclamation-sign",
        color: ColorOptions.Yellow,
    },
};
// TODO: Define base styles here too
const useTooltipIconClasses = (color) => createUseStyles({
    tooltipIcon: {
        color: getColorOptions({ color }),
    },
})();
export const FeedbackTooltip = ({ tooltipId, content, children, placement = "top", iconShown = true, disabled = false, type, dataTestId, dataLabel, dataId, }) => {
    const { glyphicon, color } = GLYPHICON_FEEDBACK_TYPE_MAP[type];
    return (React.createElement(BasicTooltip, { tooltipId: tooltipId, content: content, children: children, placement: placement, iconShown: iconShown, disabled: disabled, dataTestId: dataTestId, dataLabel: dataLabel, dataId: dataId, glyphicon: glyphicon, color: color }));
};
export const Tooltip = ({ tooltipId, content, children, placement = "top", iconShown = true, disabled = false, dataTestId, dataLabel, dataId, glyphicon = "question-sign", }) => {
    return (React.createElement(BasicTooltip, { tooltipId: tooltipId, content: content, children: children, placement: placement, iconShown: iconShown, disabled: disabled, dataTestId: dataTestId, dataLabel: dataLabel, dataId: dataId, glyphicon: glyphicon }));
};
const BasicTooltip = ({ tooltipId, content, children, placement = "top", iconShown = true, disabled = false, dataTestId, dataLabel, dataId, glyphicon = "question-sign", color = ColorOptions.LightGrey, }) => {
    let isString = false;
    const parsedChildren = parseChildren(children)[0];
    const isFormElement = parsedChildren?.props?.name && parsedChildren?.props?.label;
    if ((typeof children === "string" || typeof children === "string") &&
        typeof children !== "object") {
        isString = true;
    }
    const tooltipIconClasses = useTooltipIconClasses(color);
    if (iconShown && !isString) {
        return (React.createElement("div", { className: classNames(`tooltip--wrapper`, disabled ? "tooltip--disabled" : "", isFormElement ? "tooltip--formElement" : ""), "data-testid": dataTestId, "data-id": dataId, "data-label": dataLabel },
            children,
            React.createElement("span", { className: classNames("tooltip-icon", "glyphicon", `glyphicon-${glyphicon}`, tooltipIconClasses.tooltipIcon), id: `${tooltipId}` }),
            React.createElement(RawTooltip, { anchorId: `${tooltipId}`, placement: placement, content: content, disabled: disabled })));
    }
    return (React.createElement("div", { className: classNames(`tooltip--wrapper`, disabled ? "tooltip--disabled" : "", !!isFormElement ? "tooltip--formElement" : ""), "data-testid": dataTestId, "data-id": dataId, "data-label": dataLabel },
        isString ? (React.createElement("span", { id: `${tooltipId}`, className: "tooltip--highlight-text" }, children)) : (React.createElement("div", { id: `${tooltipId}` }, children)),
        React.createElement(RawTooltip, { anchorId: `${tooltipId}`, placement: placement, content: content, disabled: disabled })));
};
export const RawTooltip = ({ anchorId, content, placement = "top", disabled }) => {
    if (disabled)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: "chromatic-ignore" },
        React.createElement(ReactTooltip, { place: placement, style: { backgroundColor: "#354551", fontSize: "100%" }, variant: "dark", id: `tooltip_${anchorId}`, offset: 5, className: "tooltip--popup", 
            // `#${anchorId}` doesn't work if it contains b64 encoded IDs (= character breaks the selector)
            anchorSelect: `#${CSS.escape(anchorId)}`, positionStrategy: "fixed" }, content)));
};
